import { useState } from 'react'
import { AlertTriangle, BadgeCheck, Tag } from 'lucide-react'
import { useCart } from '../context/Cart'
import { eur } from '../lib/format'
import type { Totals } from '../lib/types'

export function Summary({ t, dark = false, scope = 'cart' }: { t: Omit<Totals, 'lines'>; dark?: boolean; scope?: string }) {
  const strong = dark ? 'text-white' : 'text-slate-800'
  const promoOk = t.promo && !t.promo.error
  return (
    <div className="space-y-1 text-xs" data-testid={`${scope}-summary`}>
      <div className="flex justify-between"><span>Sous-total HT</span><span className={`font-medium ${strong}`}>{eur(t.subtotal_ht)}</span></div>
      {t.discount_ht > 0 && <div className="flex justify-between text-brand-green"><span className="flex items-center gap-1"><Tag className="w-3.5 h-3.5" /> Code {t.promo?.code}{t.promo?.type === 'percent' ? ` (-${t.promo.value} %)` : ''}</span><span className="font-semibold">-{eur(t.discount_ht)}</span></div>}
      <div className="flex justify-between"><span>Livraison HT{promoOk && t.promo?.free_shipping ? <span className="text-brand-green"> (code {t.promo.code})</span> : null}</span><span className={`font-medium ${t.shipping_ht ? strong : 'text-brand-green'}`}>{t.count && !t.shipping_ht ? 'Offerte' : eur(t.shipping_ht)}</span></div>
      <div className="flex justify-between"><span>TVA (20%)</span><span className={`font-medium ${strong}`}>{eur(t.vat)}</span></div>
      <div className={`flex justify-between text-sm font-bold ${dark ? 'text-white border-slate-700' : 'text-navy-900 border-slate-200'} pt-2 border-t`}><span>Total TTC</span><span className="text-base text-brand-orange" data-testid={`${scope}-total-ttc`}>{eur(t.total_ttc)}</span></div>
    </div>
  )
}

export function PromoBox({ scope = 'cart' }: { scope?: string }) {
  const { totals, code, setCode } = useCart()
  const [input, setInput] = useState('')
  const promo = totals.promo
  const applied = promo && !promo.error
  const apply = () => {
    if (!input.trim()) return
    setCode(input.trim().toUpperCase())
    setInput('')
  }
  return (
    <div className="space-y-2" data-testid={`${scope}-promo-box`}>
      {code && promo && (
        <div className={`flex items-center justify-between gap-2 ${applied ? 'bg-emerald-50 border-emerald-200 text-emerald-800' : 'bg-amber-50 border-amber-200 text-amber-800'} border rounded-lg px-3 py-2 text-xs`} data-testid={`${scope}-promo-status`}>
          <span className="flex items-center gap-1.5 font-semibold">{applied ? <BadgeCheck className="w-4 h-4" /> : <AlertTriangle className="w-4 h-4" />}{applied ? `${promo.code} · ${promo.label || ''}` : promo.error}</span>
          <button type="button" onClick={() => setCode('')} className="shrink-0 font-bold underline" data-testid={`${scope}-promo-remove`}>Retirer</button>
        </div>
      )}
      {!applied && (
        <div className="flex gap-2">
          <input value={input} onChange={(e) => setInput(e.target.value)} onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); apply() } }} placeholder="Code promo" className="field uppercase flex-1 min-w-0 !py-2" data-testid={`${scope}-promo-input`} />
          <button type="button" onClick={apply} className="shrink-0 bg-navy-900 hover:bg-brand-ink text-white text-xs font-bold px-4 rounded-lg transition-colors" data-testid={`${scope}-promo-apply`}>Appliquer</button>
        </div>
      )}
    </div>
  )
}
